import { css as i } from "@microsoft/fast-element";
import { normalize as n } from "../common/normalize.js";
import { display as s, PropertyStyleSheetBehavior as l } from "@matrix42/fast-foundation";
import { designTokens as c } from "../design-tokens.js";
function r(e, t) {
  return new l("color", e, t);
}
function o(e) {
  return i`
    :host {
      /* Colors for primary styling*/
      color: ${c.color[e][100]};
    }
  `;
}
const p = i`
  ${n}
  ${s("inline-block")}
  :host {
    /* Base */
    vertical-align: middle;
    /* Style */
    color: inherit;
  }

  svg {
    /* Base */
    display: block;
    height: 100%;
    width: 100%;
  }
`.withBehaviors(
  r("primary", o("primary")),
  r("secondary", o("secondary")),
  r("neutral", o("neutral")),
  r("warning", o("warning")),
  r("success", o("success")),
  r("error", o("error"))
);
export {
  p as iconStyles
};
